// 任务列表里的「📺 画面」：不进任务页，弹窗只看 Windows 浏览器实时画面
import { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { Link } from "react-router-dom";
import type { TaskDTO, TaskStatus } from "@csp/shared";
import { BrowserLive } from "./BrowserLive";

/** 有浏览器在跑、值得看画面的状态 */
export const LIVE_STATUSES: TaskStatus[] = ["running", "waiting_scan", "review_required", "blocked"];

export function LiveButton({ task }: { task: TaskDTO }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") setOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);
  if (!LIVE_STATUSES.includes(task.status)) return null;
  return (
    <>
      <button className="btn btn-small" data-testid="row-live" title="看实时画面" onClick={(e) => { e.stopPropagation(); setOpen(true); }}>
        📺 画面
      </button>
      {open && createPortal(
        <div className="modal-mask" onMouseDown={(e) => e.target === e.currentTarget && setOpen(false)} onClick={(e) => e.stopPropagation()}>
          <div className="modal live-modal" role="dialog" aria-modal="true" aria-label={`#${task.no} 实时画面`}>
            <div className="row">
              <h2 style={{ margin: 0 }} translate="no">#{task.no} {task.title}</h2>
              <span className="spacer" />
              <Link to={`/tasks/${task.id}`} className="btn btn-small">打开任务</Link>
              <button className="btn btn-small" onClick={() => setOpen(false)}>✕ 关闭</button>
            </div>
            <BrowserLive taskId={task.id} mode="view" height={Math.round(window.innerHeight * 0.7)} />
          </div>
        </div>,
        document.body,
      )}
    </>
  );
}

/** 列表「进度」列的一句话：卡住 / 等扫码 / 等审核说原因，执行中说 AI 正在干什么 */
export function progressSentence(t: TaskDTO): string {
  if (t.status === "blocked") return t.blockReason || "AI 卡住了，需要人看一下";
  if (t.status === "waiting_scan") return "等担保人用 Singpass App 扫码登录";
  if (t.status === "review_required") return "已停在最终提交前，等审核";
  if (t.status === "queued") return "排队中，等浏览器空出来";
  return t.progress?.detail || t.progress?.label || "执行中";
}
